import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Pow Horizon crashed:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="glass" style={{ margin: 24, padding: 24, textAlign: "center" }}>
          <h2>Something went wrong.</h2>
          <button className="btn-accent" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
